import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAudience, IAudienceSaveResult, IAudienceShop } from 'types/api/audience';
import { IAudienceBuilderCartState } from 'types/store/audience-builder';

const initialState: IAudienceBuilderCartState = {
  isSaved: true,
  loaded: false,
  save: {
    audienceUid: null,
    shopId: null,
  },
};

export const cartSlice = createSlice({
  initialState,
  name: 'ab/cart',
  reducers: {
    clearCart: () => {
      return {
        ...initialState,
      };
    },
    clearCartAudience: (state) => {
      delete state.audience;
    },
    clearCartShop: (state) => {
      delete state.shop;
    },
    setCartAudience: (state, { payload }: PayloadAction<IAudience | undefined>) => {
      state.audience = payload;
    },
    setCartIsSaved: (state, { payload }: PayloadAction<boolean>) => {
      state.isSaved = payload;
    },
    setCartSave: (state, { payload }: PayloadAction<IAudienceSaveResult>) => {
      state.save = payload;
    },
    setCartShop: (state, { payload }: PayloadAction<IAudienceShop | undefined>) => {
      state.shop = payload;
    },
  },
});

export const cartReducer = cartSlice.reducer;
